import {Component, Input} from '@angular/core';
import {KeyValueItemData} from "../../interfaces/key-value-item-data";

@Component({
  selector: 'brt-key-value-item',
  templateUrl: './key-value-item.component.html',
  styleUrls: ['./key-value-item.component.scss']
})
export class KeyValueItemComponent {
  @Input('data') data!: KeyValueItemData;
}
